var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkCreateProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.253 7.098L12.06 5.905 7.594 10.37 5.94 8.717 4.747 9.911l2.25 2.25c.33.33.864.33 1.193 0l5.063-5.063z",
    fill: "#1B264F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.033a9 9 0 1118 0 9 9 0 01-18 0zm1.688 0a7.313 7.313 0 1114.625 0 7.313 7.313 0 01-14.625 0z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/images/checkmarkCreateProject-50d4bdf4.svg";
export { SvgCheckmarkCreateProject as ReactComponent };